module.exports = __webpack_public_path__ + "img/8.203779e7.jpg";